
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raffles",
      function () {
        return require("private-next-pages/raffles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raffles"])
      });
    }
  